export const SET_PORTAL = "SET_PORTAL";
export const SET_USER = "SET_USER";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";

export const SET_OPEN_USERS = "SET_OPEN_USERS";
export const OPEN_USER = "OPEN_USER";
export const CLOSE_USER = "CLOSE_USER";

export const SET_OPEN_LICENCES = "SET_OPEN_LICENCES";
export const OPEN_LICENSE = "OPEN_LICENCE";
export const CLOSE_LICENCE = "CLOSE_LICENCE";

export const SET_ROUTE_MESSAGE = "SET_ROUTE_MESSAGE";
export const DEL_ROUTE_MESSAGE = "DEL_ROUTE_MESSAGE";
